import { signal } from './SignalsService'

function init() {
  signal.on('ACTION:REEL-SPIN', () => {
    if (game.models.SpinModel.get().chance.find((element) => element === true)){

      if (game.models.FreespinModel.get().left > 0) {
        signal.dispatch('SCATTER:WIN')
      }
      else {
        signal.dispatch('SCATTER:LOSE')
      }
    }
  })
}

export const ScatterService = { init }
